import gql from 'graphql-tag';

const SharedBits = `
    ID
    Created
    Confirmed
    Cancelled
    Responded
    Requested
    Comment
    Notes
    Contact {
        ID
		Name
		ClergyCategory
    }
    PurchaseOrder {
        ID
        XeroID
        Invoice {
            ID
            XeroID
            XeroReference
        }
    }
    Responses {
        edges {
            node {
                ID
                Declined
                Responded
                Comment
                Supplier {
                    ID
                    Name
                }
            }
        }
    }
    DeliveryDate
    DeliveryTime
    DeliveryAddress
    Duration
`;

export const OrdersFragmentInclude = `
    ${SharedBits}
    BookingItems(limit: 999) {
        edges {
            node {
                ID
                Title
                Quantity
                UnitPrice
                Total
                Comment
                Returns
                Product {
                    ID
                    Title
                    InternalItemID
                    BasePrice
                    BaseWorth
                    ImagePortraitURL
                    ImageLandscapeURL
                    GST
                    ITC
                  }
                Variation {
                    ID
                    InternalItemID
                    ShortDescription
                    GST
                    Price
                    ITC
                    Worth
                }
            }
        }
    }
`;

export const BookingsFragmentInclude = `
    ${SharedBits}
`;

export const AllSuppliers = gql`
    fragment AllSuppliers on Funeral {
        Audiovisuals {
            ${BookingsFragmentInclude}
        }
        Caterers {
            ${OrdersFragmentInclude}
        }
        Clergy {
            ${BookingsFragmentInclude}
        }
        CommittalBookings {
            ${OrdersFragmentInclude}
        }
        DefaultMusicians {
            ${BookingsFragmentInclude}
        }
        EnterMusicians {
            ${BookingsFragmentInclude}
        }
        EnterMusicians {
            ${BookingsFragmentInclude}
        }
        ExitMusicians {
            ${BookingsFragmentInclude}
        }
        Florists {
            ${OrdersFragmentInclude}
        }
        GraveDigger {
            ${BookingsFragmentInclude}
        }
        GraveLedger {
            ${BookingsFragmentInclude}
        }
        GravesideMusicians {
            ${BookingsFragmentInclude}
        }
        LimoBookings {
            ${BookingsFragmentInclude}
        }
        MemorialStationary {
            ${OrdersFragmentInclude}
        }
        NewspaperNotices {
            ${BookingsFragmentInclude}
        }
        OtherMusicians {
            ${BookingsFragmentInclude}
        }
        PersonalisedTouches {
            ${OrdersFragmentInclude}
        }
        ReflectionMusicians {
            ${BookingsFragmentInclude}
        }
        RslMasonic {
            ${BookingsFragmentInclude}
        }
        RefreshmentsBookings {
            ${OrdersFragmentInclude}
        }
        ServiceBookings {
            ${BookingsFragmentInclude}
        }
        ViewingBookings {
            ${BookingsFragmentInclude}
        }
    }
`;
